Alpine.data('alpine_pattern_carousel', () => ({
  swiper: null,
  initSwiper() {
    this.swiper = new Swiper(this.$refs.container, {
      autoplay: false,
      keyboard: true,
      lazy: {
        loadOnTransitionStart: true
      },
      loop: true,
      navigation: {
        nextEl: '.button-next-pattern',
        prevEl: '.button-prev-pattern'
      },
      slidesPerGroup: 5,
      slidesPerView: 5,
      breakpoints: {
        1400: {
          slidesPerGroup: 5,
          slidesPerView: 5,
        },
        1024: {
          slidesPerGroup: 4,
          slidesPerView: 4,
        },
        800: {
          slidesPerGroup: 3,
          slidesPerView: 3,
        },
        500: {
          slidesPerGroup: 2,
          slidesPerView: 2,
        },
        320: {
          slidesPerGroup: 1,
          slidesPerView: 1,
        },
      },
    });
  },

  init() {
    this.initSwiper();
  },
}));
